import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getLegal = createServerFn()
    .handler(async () => {
        const response = await api('get', 'legal');
        return response.data || {};
    });
